<template>
  <div class="cp-ShoppingList_Container">
    <div class="container">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="flex-grow-1 flex-shrink-0">
          <div class="h6 text-small text-uppercase text-gray-600 mb-1">{{ selected }}</div>
          <div class="cp-ShoppingList_CartText h3 mb-1 mb-sm-0">{{ sharedState.count }}</div>
        </div>
        <div class="flex-shrink-0 text-right">
          <button
            class="btn btn-success cp-ShoppingList_AddToCartButton"
            type="submit"
            :disabled="!hasCheckedItems"
          >
            {{ add_to_cart }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShoppingListStore from "./ShoppingListStore";

export default {
  name: "StoreShoppingList_Cart",
  props: {
    selected: {
      required: true,
      type: String,
    },
    add_to_cart: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      sharedState: ShoppingListStore.state,
    };
  },
  computed: {
    hasCheckedItems() {
      return this.sharedState.count > 0;
    },
  },
};
</script>
